import { useEffect } from 'react';
import TextIconOptionTile from '../../common/action-tile/TextIconOptionTile';
import NavHeader from '../../common/NavHeader/NavHeader';
import CustomContainer from '../../common/wrapper/Container';
import VerticalStack from '../../common/wrapper/VerticalStack';
import CustomeHeading from '../../customeHeading/customeHeading';
import { TeamMemberList } from '../../redux/actions/teamMemberList/getTeamMemberList';
import { BOOKING_LINK_STEP } from './constants';
import Skeleton from 'react-loading-skeleton';
import { APP_COMPONENT_SIZE } from '../../../utils/constants';

function SelectTeamMember({
    setStep,
    setSelectedTeamMember,
    selectedTreatment,
    setSelectedTreatmentId,
}) {
    const {
        initTeamMemberList,
        teamMemberListQueryData: { data: teamMemberData, loading: teamMemberLoading },
    } = TeamMemberList();
    const treatmentIds = [];
    // Assuming each team member has an "id" property
    selectedTreatment?.forEach((treatments) => {
        // Check if the "id" property exists and is a valid value
        if (treatments.id) {
            treatmentIds.push(treatments.id);
        }
    });

    useEffect(() => {
        if (treatmentIds?.length > 0)
            initTeamMemberList({
                treatmentId: treatmentIds,
            });
        setSelectedTreatmentId(treatmentIds);
    }, []);

    const uniqueTeamMember = Array.from(
        new Set(
            teamMemberData?.getAvailableTeamMembers?.data?.team_members?.map(
                (teamMember) => teamMember.id
            )
        )
    ).map((id) => {
        return teamMemberData?.getAvailableTeamMembers?.data?.team_members?.find(
            (teamMember) => teamMember.id === id
        );
    });

    useEffect(() => {
        setSelectedTeamMember(uniqueTeamMember[0]);
    }, [uniqueTeamMember]);
    return (
        <CustomContainer removeTopPadding>
            <VerticalStack space={20}>
                <NavHeader
                    isSticky
                    isBackOnly
                    handleOnBack={() => setStep(BOOKING_LINK_STEP.DATE_AND_TIME)}
                />
                <CustomeHeading
                    Title="Select a team member"
                    Desc="Select a team member for your treatment. Availability may vary, and some treatments may only be offered by specific team members."
                />
                {teamMemberLoading ? (
                    <Skeleton height={48} borderRadius={10} />
                ) : (
                    <TextIconOptionTile
                        // size={APP_COMPONENT_SIZE.medium}
                        checked={true}
                        onChange={() => setSelectedTeamMember(uniqueTeamMember[0])}
                        useAvatar
                        avatarProps={{
                            src: uniqueTeamMember[0]?.image,
                            name: uniqueTeamMember[0]?.name,
                            // size: '26'
                        }}
                        title={uniqueTeamMember[0]?.name}
                        subtitle={uniqueTeamMember[0]?.occupations.join(', ')}
                    />
                )}
            </VerticalStack>
        </CustomContainer>
    );
}
export default SelectTeamMember;
